import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import StructureOptionsGroup from './StructureOptionsGroup';

import './StructureOptionsDialog.scss';

function StructureOptions(props) {
  const { ownCurrentOptions, wrapperClassName } = props;
  const groups = ownCurrentOptions.get('groups');
  const groupsIds = ownCurrentOptions.get('groupsIds');
  return (
    <section className={cn('structure-options-dialog-groups-wrapper', wrapperClassName)}>
      {groupsIds.map((groupsId) => (
        <StructureOptionsGroup {...props} key={groupsId} group={groups.get(groupsId)} />
      ))}
    </section>
  );
}

StructureOptions.propTypes = {
  id: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
  ownCurrentOptions: PropTypes.object,
  onApplyClick: PropTypes.func.isRequired,
};

export default StructureOptions;
